import { loginRoute, logoutRoute } from 'App/common/routeLookup';

function isOnLoginPage() {
    return (
        [loginRoute, logoutRoute].includes(window.location.pathname)
    );
}

export default isOnLoginPage;
